import React, { useState } from "react";
import {
  Box,
  Card,
  Flex,
  Text,
  ThemeIcon,
  Tooltip,
  SimpleGrid,
  Paper,
  Image,
  Anchor,
  NumberFormatter,
  Grid,
  Title,
  Badge,
  Group,
  Button,
  Modal,
  ScrollArea,
} from "@mantine/core";
import { useSelector, useDispatch } from "react-redux";
import { IconHome, IconInfoCircle } from "@tabler/icons-react";
import LoadingData from "../../../../ui/LoadingData";
import NoData from "../../../../ui/NoData";
import NoImage from "../../../../../assets/img/images/no-images.png";
import dayjs from "dayjs";
import { IconTrash } from "@tabler/icons-react";
import { useParams } from "react-router-dom";
import { modalDeleteDataItemsOrder } from "../../../../ui/Prompt/modalDeleteDataItemsOrder";
import { getOrderDetail } from "../../../../../store/orderDetail";
import { getOrderItems } from "../../../../../store/orderItems";
import { deleteItemsOrder } from "../../../../../services/orders";
import { calculation } from "../../../../../services/calculation";
import {
  loadingNotification,
  completedLoadingNotification,
  notificationError,
} from "../../../../ui/Notifications";
import FormAdjustOrderProduct from "../Form/FormAdjustOrderProduct";
import FormAdustImageOrderProduct from "../Form/FormAdjustImageOrderProduct";

const OrderProductList = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const orderId = params.order_id;
  const [openModalEditItem, setOpenModalEditItem] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const { isLoadingOrderItems, dataOrderItems } = useSelector(
    (state) => state.order_items,
  );
  const { isLoadingOrder, summary, general, logistic } = useSelector(
    (state) => state.order_detail,
  );

  // image order item
  const [detailDataImage, setDetailDataImage] = useState(null);
  const [modalAdjustImageOrderItem, setModalAdjustImageOrderItem] =
    useState(false);

  // original info toggle
  const [expandedOriginalInfo, setExpandedOriginalInfo] = useState({});

  // handle open modal adjust image variant
  const handleOpenModalAdjustImageOrderItem = (dataItems) => {
    setModalAdjustImageOrderItem(true);
    setDetailDataImage(dataItems);
  };
  const onCloseModalAdjustImageOrderItem = () => {
    setModalAdjustImageOrderItem(false);
    setDetailDataImage(null);
  };

  const toggleOriginalInfo = (itemId) => {
    setExpandedOriginalInfo((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const onCloseModalEditItem = () => {
    setOpenModalEditItem(false);
    setDetailData(null);
  };

  const remapDataItems = (dataProduct) => {
    const mappingVariants = (dataVariants) => {
      if (dataVariants.length > 0) {
        if (dataVariants[0].name !== "Product Name") {
          const remapVariant = dataVariants.map((val, index) => {
            return (
              <Text
                component="span"
                fz={11}
                fw="bold"
                key={index}
                tt="capitalize"
                c="dimmed"
              >
                {val.name}:{" "}
                <Text component="span" fz={11} fw={500}>
                  {val.option}
                </Text>{" "}
                {index !== Object.keys(dataVariants).length - 1 ? "," : ""}
              </Text>
            );
          });
          return remapVariant;
        }
      }
    };

    const mappingCategoryProduct = (dataCategory) => {
      if (dataCategory.length > 0) {
        // eslint-disable-next-line
        const remapDataCategory = dataCategory.map((val, index) => {
          return (
            <Text component="span" fz={12} fw="500">
              {index > 0 ? (
                <Text component="span" fz={12} fw="500">
                  /
                </Text>
              ) : (
                ""
              )}{" "}
              {val.name}
            </Text>
          );
        });
        return remapDataCategory;
      } else {
        return (
          <Text fz={12} fw="500" color="dimmed">
            -
          </Text>
        );
      }
    };

    const handleSkuStatus = (skuStatus) => {
      if (skuStatus.length > 0) {
        return skuStatus[0].attributes.name;
      } else {
        return "N/A";
      }
    };

    const handleReloadDataDetail = async () => {
      const loadingCalculation = loadingNotification(
        "Waiting Calculation Order",
        "Please Wait. . .",
      );
      const responseCalculation = await calculation(orderId);
      if (responseCalculation.success) {
        dispatch(getOrderDetail(orderId));
        dispatch(getOrderItems(orderId));
        completedLoadingNotification(
          loadingCalculation,
          "Calculation Order Successfully",
          "This order has been completed in calculation",
        );
      }
    };

    const handleDeleteItems = (dataProduct) => {
      modalDeleteDataItemsOrder(
        "Product",
        orderId,
        dataProduct.id,
        dataProduct.productName,
        deleteItemsOrder,
        handleReloadDataDetail,
      );
    };

    const goToSourceUrl = (sourceUrl) => {
      if (sourceUrl) {
        window.open(`${sourceUrl}`, "_blank");
      } else {
        notificationError(
          "Open Original URL Failed",
          "Original Source Url Does not Exist",
        );
      }
    };

    const handleEditOrderItem = (dataItems) => {
      setOpenModalEditItem(true);
      setDetailData(dataItems);
    };

    const showDataPound = (totalProductWeight) => {
      const dataTotalWeight = totalProductWeight

      const convertDataPound = Number(dataTotalWeight) * 2.20462

      return `${convertDataPound.toFixed(3)} pound`
    } 

    const remapDataList = dataProduct.map((val, index) => {
      return (
        <Card
          key={index}
          shadow="sm"
          padding="lg"
          radius="md"
          withBorder
          mb={20}
        >
          <Card.Section style={{ backgroundColor: "#eeefef" }}>
            <Flex gap="xs" align="center" wrap="wrap" p={12}>
              <ThemeIcon variant="transparent" color="blue" size="sm">
                <IconHome style={{ width: "70%", height: "70%" }} />
              </ThemeIcon>
              <Text fz={12} fw="500" color="blue">
                {val.supplierName
                  ? val.supplierName
                  : "This product has no supplier information"}
              </Text>
              <Text fz={12} fw="500" color="dimmed">
                Send From: {val.warehouse ? val.warehouse : ""}{" "}
                {val.warehouse === null
                  ? val.supplierName !== null
                    ? `${val.supplierName}`
                    : ""
                  : ""}{" "}
                {val.cityName ? `, ${val.cityName}` : ""}
              </Text>
            </Flex>
          </Card.Section>
          <SimpleGrid cols={2} verticalSpacing="md" spacing="md">
            <Box style={{ borderRight: "2px solid #eeefef" }}>
              <Flex gap="sm" align="start" py={10}>
                <Tooltip label="Click to Change Image" position="right">
                  <Paper
                    shadow="sm"
                    w={82}
                    mt={4}
                    withBorder
                    radius="md"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleOpenModalAdjustImageOrderItem(val)}
                  >
                    <Image
                      w={80}
                      h={80}
                      radius="md"
                      src={val.imageUrl !== null ? val.imageUrl : NoImage}
                    />
                  </Paper>
                </Tooltip>
                <Box style={{ flex: "0 0 80%" }}>
                  <Text fz={14} fw="600" lineClamp={2}>
                    {val.productName}
                  </Text>
                  <Box h={20} my={6}>
                    {mappingVariants(val.variants)}
                  </Box>
                  <SimpleGrid
                    cols={4}
                    verticalSpacing="md"
                    spacing="md"
                    my={10}
                  >
                    <Box>
                      <Text fz={12} c="gray.6">
                        Original SKU
                      </Text>
                      <Text fz={12} fw="500">
                        {val.originalSku ? val.originalSku : "-"}
                      </Text>
                    </Box>
                    <Box>
                      <Text fz={12} c="gray.6">
                        ALI SKU
                      </Text>
                      <Text fz={12} fw="500">
                        {val.aliSku ? val.aliSku : "-"}
                      </Text>
                    </Box>
                    <Box>
                      <Text fz={12} c="gray.6">
                        Product ID
                      </Text>
                      <Anchor fz={12} underline="hover" c="blue" fw="500">
                        {val.productId !== null
                          ? val.productId
                          : "No Product ID"}
                      </Anchor>
                    </Box>
                    <Box></Box>
                    <Box>
                      <Text fz={12} c="gray.6">
                        Admin Note
                      </Text>
                      <Text fz={12} fw="500">
                        {val.adminNote}
                      </Text>
                    </Box>
                    <Box>
                      <Text fz={12} c="gray.6">
                        User Note
                      </Text>
                      <Text fz={12} fw="500">
                        {val.userNote}
                      </Text>
                    </Box>
                    <Box>
                      <Text fz={12} c="gray.6">
                        Channel Price
                      </Text>
                      <Text fz={12} fw="500">
                        {val.channelPrice ? (
                          <NumberFormatter
                            prefix={`${val.currency} `}
                            thousandSeparator=","
                            decimalSeparator="."
                            value={val.channelPrice}
                          />
                        ) : (
                          "-"
                        )}
                      </Text>
                    </Box>
                    <Box>
                      <Text fz={12} c="gray.6">
                        Point Reward
                      </Text>
                      <Text fz={12} fw="500">
                        {val.reward_point !== null ? val.reward_point : "-"}{" "}
                        Poin
                      </Text>
                    </Box>
                  </SimpleGrid>
                  <Box
                    mb={10}
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleOriginalInfo(val.id)}
                  >
                    <Group spacing="xs">
                      <ThemeIcon variant="transparent" size="sm">
                        <IconInfoCircle size={16} />
                      </ThemeIcon>
                      <Text fz={12} fw="500" color="blue">
                        Original Info
                      </Text>
                      <Text fz={10} c="dimmed">
                        {expandedOriginalInfo[val.id] ? "(Hide)" : "(Show)"}
                      </Text>
                    </Group>
                  </Box>
                  {expandedOriginalInfo[val.id] && (
                    <SimpleGrid
                      cols={2}
                      verticalSpacing="md"
                      spacing="md"
                      mb={10}
                    >
                      <Box>
                        <Text fz={12} c="gray.6">
                          Original Name
                        </Text>
                        <Text fz={12} fw="500">
                          {val.originalName || "-"}
                        </Text>
                      </Box>
                      <Box>
                        {val.variants &&
                          val.variants.map((variant, idx) => (
                            <Box key={idx}>
                              <Text fz={12} c="gray.6">
                                {variant.original_name}
                              </Text>
                              <Text fz={12} fw="500">
                                {variant.original_option}
                              </Text>
                            </Box>
                          ))}
                      </Box>
                    </SimpleGrid>
                  )}
                  <SimpleGrid
                    cols={2}
                    verticalSpacing="md"
                    spacing="md"
                    pt={10}
                  >
                    <Box>
                      <Text fz={12} c="gray.6">
                        Created By
                      </Text>
                      <Box>
                        <Anchor
                          fz={14}
                          underline="hover"
                          c={val.creator !== null ? "blue" : "gray.6"}
                          mb={4}
                          fw="500"
                        >
                          {val.creator !== null ? val.creator.name : "No User"}
                        </Anchor>
                        <Text fz={10} c="gray.6">
                          {dayjs(val.createdAt).format("DD/MMMM/YYYY")} -{" "}
                          {dayjs(val.createdAt).format("HH:mm:ss")}
                        </Text>
                      </Box>
                    </Box>
                    <Box>
                      <Text fz={12} c="gray.6">
                        Updated By
                      </Text>
                      <Box>
                        <Anchor
                          fz={14}
                          underline="hover"
                          c={val.updater !== null ? "blue" : "gray.6"}
                          mb={4}
                          fw="500"
                        >
                          {val.updater !== null ? val.updater.name : "No User"}
                        </Anchor>
                        <Text fz={10} c="gray.6">
                          {dayjs(val.updatedAt).format("DD/MMMM/YYYY")} -{" "}
                          {dayjs(val.updatedAt).format("HH:mm:ss")}
                        </Text>
                      </Box>
                    </Box>
                  </SimpleGrid>
                </Box>
              </Flex>
            </Box>
            <Box>
              <SimpleGrid cols={4} verticalSpacing="md" spacing="md" my={10}>
                <Box>
                  <Text fz={12} c="gray.6">
                    Quantity
                  </Text>
                  <Text fz={12} fw="500">
                    {val.quantity} {val.unit_name}{" "}
                    {[
                      "bulk_price",
                      "bundle_price",
                      "bulk_price_manual",
                      "bundle_price_manual",
                    ].includes(val.originalPriceType || "")
                      ? `( ${val.quantity_per_unit} ${val.base_unit_name} )`
                      : ""}
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    BM
                  </Text>
                  <Text fz={12} fw="500">
                    {val.bm} %
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    PPH
                  </Text>
                  <Text fz={12} fw="500">
                    {val.pph} %
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    PPN
                  </Text>
                  <Text fz={12} fw="500">
                    {val.ppn} %
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Cbm / {val.unit_name}
                  </Text>
                  <Text fz={12} fw="500">
                    {val.cbmPerUnit} m³
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Total Cbm
                  </Text>
                  {!isLoadingOrder ? (
                    <Text fz={12} fw="500">
                      {val.totalCbm} m³{" "}
                      <Text component="span" fz={12} fw="bold">
                        ({((val.totalCbm / logistic.totalCbm) * 100).toFixed(2)}
                        ) %
                      </Text>
                    </Text>
                  ) : (
                    ""
                  )}
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Weight / {val.unit_name}
                  </Text>
                  <Text fz={12} fw="500">
                    {val.weight} {val.weightUnit}
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Total Weight
                  </Text>
                  <Text fz={12} fw="500">
                    {general.showAsPound ? showDataPound(val.quantity * val.weight) : ''}  {general.showAsPound ? `(${val.quantity * val.weight} ${val.weightUnit})` : `${val.quantity * val.weight} ${val.weightUnit}`}
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Landed Cost / {val.unit_name} (Inc VAT)
                  </Text>
                  <Text fz={12} fw="500">
                    <NumberFormatter
                      prefix={`${summary.orderCurrency} `}
                      thousandSeparator=","
                      decimalSeparator="."
                      decimalScale={2}
                      fixedDecimalScale={true}
                      value={val.landed_cost ? val.landed_cost : 0}
                    />
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Rev Landed Cost / {val.unit_name}
                  </Text>
                  <Text fz={12} fw="500">
                    <NumberFormatter
                      prefix={`${summary.orderCurrency} `}
                      thousandSeparator=","
                      decimalSeparator="."
                      decimalScale={2}
                      fixedDecimalScale={true}
                      value={
                        val.revised_landed_cost ? val.revised_landed_cost : 0
                      }
                    />
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Hscodes
                  </Text>
                  <Text fz={12} fw="500">
                    {val.hscodes !== null ? val.hscodes : "-"}
                  </Text>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Volumetric Weight
                  </Text>
                  <Text fz={12} fw="500">
                    {(val.vwWidth * val.vwLength * val.vwHeight) / 5000} kgv
                  </Text>
                </Box>
              </SimpleGrid>
              <Grid pt={8} mb={20}>
                <Grid.Col span={3}>
                  <Box>
                    <Text fz={12} c="gray.6">
                      Landed Cost / {val.unit_name} (Exc VAT)
                    </Text>
                    <Text fz={12} fw="500">
                      <NumberFormatter
                        prefix={`${summary.orderCurrency} `}
                        thousandSeparator=","
                        decimalSeparator="."
                        decimalScale={2}
                        fixedDecimalScale={true}
                        value={
                          val.landed_cost_exclude_vat
                            ? val.landed_cost_exclude_vat
                            : 0
                        }
                      />
                    </Text>
                  </Box>
                </Grid.Col>
                <Grid.Col span={8}>
                  <Box>
                    <Text
                      fz={12}
                      c="gray.6"
                      mb={val.categoryProduct.length > 0 ? -4 : ""}
                    >
                      Categories
                    </Text>
                    {mappingCategoryProduct(val.categoryProduct)}
                  </Box>
                </Grid.Col>
              </Grid>
              <SimpleGrid cols={2} verticalSpacing="md" spacing="md" mb={14}>
                <Box>
                  <Text fz={12} c="gray.6">
                    Price / {val.unit_name}
                  </Text>
                  <Box>
                    <Title order={4} fw={600} c="blue">
                      <NumberFormatter
                        prefix={`${summary.orderCurrency} `}
                        thousandSeparator=","
                        decimalSeparator="."
                        decimalScale={2}
                        fixedDecimalScale={true}
                        value={val.price}
                      />
                    </Title>
                    {summary.goodsCurrency !== summary.orderCurrency ? (
                      <Text fz={12}>
                        (
                        <NumberFormatter
                          prefix={`${summary.goodsCurrency} `}
                          thousandSeparator=","
                          decimalSeparator="."
                          decimalScale={2}
                          value={val.originalPrice}
                        />
                        )
                      </Text>
                    ) : (
                      ""
                    )}
                  </Box>
                </Box>
                <Box>
                  <Text fz={12} c="gray.6">
                    Sub Total
                  </Text>
                  <Box>
                    <Title order={4} fw={600} c="red">
                      <NumberFormatter
                        prefix={`${summary.orderCurrency} `}
                        thousandSeparator=","
                        decimalSeparator="."
                        decimalScale={2}
                        fixedDecimalScale={true}
                        value={val.price * val.quantity}
                      />
                    </Title>
                    {summary.goodsCurrency !== summary.orderCurrency ? (
                      <Text fz={12}>
                        (
                        <NumberFormatter
                          prefix={`${summary.goodsCurrency} `}
                          thousandSeparator=","
                          decimalSeparator="."
                          decimalScale={2}
                          value={val.originalPrice * val.quantity}
                        />
                        )
                      </Text>
                    ) : (
                      ""
                    )}
                  </Box>
                </Box>
              </SimpleGrid>
            </Box>
          </SimpleGrid>
          <Card.Section withBorder inheritPadding py="md">
            <Flex justify="space-between" align="center">
              <Badge
                size="lg"
                variant="light"
                color="black"
                tt="capitalize"
                fw="500"
              >
                {val.skuStatus
                  ? handleSkuStatus(val.skuStatus)
                  : "This product has no status"}
              </Badge>
              <Group>
                <Button
                  size="xs"
                  radius="sm"
                  variant="outline"
                  color="black"
                  onClick={() => goToSourceUrl(val.originalSourceUrl)}
                >
                  Product Sources
                </Button>
                <Button
                  size="xs"
                  radius="sm"
                  variant="outline"
                  onClick={() => handleDeleteItems(val)}
                >
                  <IconTrash size={16} />
                </Button>
                <Button
                  size="xs"
                  radius="sm"
                  onClick={() => handleEditOrderItem(val)}
                >
                  Edit
                </Button>
              </Group>
            </Flex>
          </Card.Section>
        </Card>
      );
    });

    return remapDataList;
  };
  return (
    <Box>
      {isLoadingOrderItems ? (
        <LoadingData />
      ) : dataOrderItems.length > 0 ? (
        remapDataItems(dataOrderItems)
      ) : (
        <NoData />
      )}
      <Modal
        opened={openModalEditItem}
        onClose={onCloseModalEditItem}
        centered
        closeOnClickOutside={false}
        size="80%"
        title={<Text fw="Bold">Edit Order Item</Text>}
        scrollAreaComponent={ScrollArea.Autosize}
        withCloseButton={false}
      >
        <FormAdjustOrderProduct
          detailItem={detailData}
          onCloseModal={onCloseModalEditItem}
        />
      </Modal>

      <Modal
        opened={modalAdjustImageOrderItem}
        onClose={() => onCloseModalAdjustImageOrderItem()}
        centered
        closeOnClickOutside={false}
        size="lg"
        title={<Text fw="Bold">Edit Image</Text>}
        withCloseButton={true}
      >
        <FormAdustImageOrderProduct
          detailItem={detailDataImage}
          onCloseModal={onCloseModalAdjustImageOrderItem}
        />
      </Modal>
    </Box>
  );
};

export default OrderProductList;
